<template>
  <div class="content">
    <header-top></header-top>
    <div class="form">
      <div class="headerBox">
        <div>欢迎注册</div>
        <div class="link">
          <router-link to="/login/mobile">已有账号，快捷登录&gt;</router-link>
        </div>
      </div>
      <div class="box">
        <el-form
          :model="registerForm"
          :rules="formRules"
          ref="registerFormRef"
          label-width="100px"
          label-position="left"
        >
          <el-form-item label="手机号：" prop="mobile">
            <el-input v-model="registerForm.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>

          <el-form-item class="code">
            <el-input v-model="registerForm.code" placeholder="请输入验证码"></el-input>
            <el-button
              type="primary"
              @click="getVerify"
              style="width:140px;"
              :disabled="disabled=!show"
            >
              <span v-show="show">获取验证码</span>
              <span v-show="!show" class="count">{{count}} s后重新获取</span>
            </el-button>
          </el-form-item>

          <!-- 选择框 -->
          <el-form-item class="roleSelect" label="用户类型：" prop="role" required>
            <el-select v-model="registerForm.role" placeholder="请选择" @change="changePeople">
              <el-option
                v-for="item in roleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 上传图片 -->
          <el-form-item>
            <div v-if="registerForm.role === 'company'">请上传营业执照，以及法人身份证或本人身份证正反面，格式为jpg或png，大小不能超过5M</div>
            <div v-if="registerForm.role === 'gov'">请上传本人身份证正反面，格式为jpg或png，大小不能超过5M</div>
            <el-upload
              :action="domain"
              :before-upload="beforUp"
              :on-success="handleSuccess"
              :data="formData"
              :show-file-list="false"
              :multiple="true"
              accept="image/png, image/jpg, image/jpeg"
              v-if="registerForm.role === 'company' || registerForm.role === 'gov'"
              class="uploadBox"
            >
              <div v-for="(item,index) in registerForm.options" :key="index" class="imgBox">
                <img :src="item" />
                <span class="iconfont icon-guanbi" @click.stop="deleteImg(index)"></span>
              </div>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="地区：" required>
            <city-picker
              ref="cityPicker"
              :default-city="defaultCity"
              :level="2"
              @change="changeSelece"
            ></city-picker>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="save" class="btn">注册</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import { uploadImg, create, register } from "@/api/common.js";
import headerTop from "@/components/header.vue";
import cityPicker from "@/components/CityPicker";
import foot from "@/components/footer.vue";

export default {
  components: {
    headerTop,
    cityPicker,
    foot
  },
  data() {
    // 设置确认密码的验证规则
    const checkPassAgain = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.registerForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      registerForm: {
        mobile: "",
        code: "",
        options: [],
        role: "",
        province: "",
        city: "",
        hash: "",
        key: ""
      },
      formRules: {
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          },
          {
            trigger: "blur",
            pattern: /^1[34578]\d{9}$/,
            message: "目前只支持中国大陆的手机号码"
          }
        ]
      },
      roleOptions: [
        {
          label: "市民",
          value: "others"
        },
        {
          label: "企业主",
          value: "company"
        },
        {
          label: "监管者",
          value: "gov"
        }
      ],
      domain: "",
      baseUrl: "",
      formData: {},
      //   省市区初始值
      defaultCity: {
        province: "福建省",
        city: "厦门市"
      },
      show: true,
      count: "", // 初始化次数
      timer: null
    };
  },
  methods: {
    beforUp() {
      return uploadImg().then(res => {
        this.domain = res.data.uploadUrl;
        this.formData = {
          token: res.data.uploadToken
        };
        this.baseUrl = res.data.baseUrl;
      });
    },
    handleSuccess(response, file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].size / 1024 > 5000) {
          return;
        }
      }
      this.registerForm.options.push(this.baseUrl + response.hash);
    },
    // 删除图片
    deleteImg(index) {
      this.registerForm.options.splice(index, 1);
    },
    getVerify() {
      // 验证手机号
      if (this.checkPhone()) {
        create('registCode', { mobile: this.registerForm.mobile })
        .then(res => {
          this.registerForm.hash = res.data.hash;
          this.registerForm.key = res.data.key;
          if (res.code === 0) {
            const TIME_COUNT = 60; //更改倒计时时间
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.show = false;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                } else {
                  this.show = true;
                  clearInterval(this.timer); // 清除定时器
                  this.timer = null;
                }
              }, 1000);
            }
          }
        });
      } else {
       return false;
      }
    },
    checkPhone() {
      let phone = this.registerForm.mobile;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.$message.error("请填写正确的手机号");
        return false;
      }else {
        return true;
      }
    },
    // 提交
    save() {
      if (this.registerForm.role === "") {
        return this.$message.error("请选择用户类型");
      } else if (
        this.registerForm.role !== "others" &&
        this.registerForm.options.length === 0
      ) {
        return this.$message.error("请上传相应图片");
      }

      if (!this.registerForm.city) {
        return this.$message.error("请选择城市");
      }
      this.$refs.registerFormRef.validate(valid => {
        if (valid) {
          create('regist',{ ...this.registerForm }).then(res => {
            this.$message.success("注册成功");
            this.$router.push({
              path: "/login/mobile"
            });
          });
        } else {
          return this.$message.error("注册失败");
        }
      });
    },
    changePeople() {
      if (this.registerForm.role === "others") {
        this.registerForm.fileList = [];
      }
    },
    changeSelece(e) {
      this.registerForm.province = e.data[0];
      this.registerForm.city = e.data[1];
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
}
.form {
  width: 560px;
  margin: 60px auto 0;
}
.headerBox {
  font-size: 22px;
  display: flex;
  justify-content: space-between;
  div:nth-child(1) {
    width: 140px;
    text-align-last: justify;
  }
  .link {
    width: 250px;
    text-align-last: justify;
  }
  a {
    font-size: 18px;
    text-decoration: none;
    color: #41a5ef;
  }
}
.box {
  margin-top: 20px;
}
.el-icon-plus {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  line-height: 100px;
}
.imgBox {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 100px;
  height: 100px;
  margin: 0 3px 3px 0;
  img {
    width: 100%;
    height: 100%;
  }
  span {
    position: absolute;
    top: -10px;
    right: 0;
    color: #ccc;
  }
}

/deep/ .uploadBox {
  .el-upload {
    text-align: left;
  }
  i {
    text-align: center;
  }
}

.code {
  .el-input {
    width: 310px;
    margin-right: 10px;
  }
}
.el-select {
  width: 460px;
}
@media screen and (min-width: 320px) and (max-width: 980px) {
  .form {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .headerBox {
    display: block;
    div:nth-child(1) {
      width: auto;
      text-align-last: initial;
    }
    .link {
      width: auto;
      text-align-last: initial;
    }
  }
  .code {
    .el-input {
      width: 100%;
    }
  }
}
</style>
<style>
  @media screen and (min-width: 320px) and (max-width: 980px) {
    .code .el-form-item__content {
        /*margin-left: 0 !important;*/
    }
    .code .el-button {
      margin-top: 15px;
    }
    .roleSelect .el-select {
      width: 100%;
    }
  }
  .el-button.btn{
    width:100%;
    color: #FFF;
    background-color: #409EFF;
    border-color: #409EFF;
    letter-spacing: 30px;
    text-indent: 30px;
    font-size: 22px;
   
}
</style>

